// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, *::before, *::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

:root {
  --bg-deep:       #0a0e1a;
  --bg-panel:      #111827;
  --tile-blank:    #1a2235;
  --tile-border:   #2a3a55;
  --tile-revealed: #0d1f3c;
  --tile-face:     #e8f4ff;
  --accent-teal:   #00d4c8;
  --accent-glow:   rgba(0, 212, 200, 0.4);
  --accent-warm:   #f5c842;
  --key-top:       #1f2d45;
  --key-shadow:    #080d18;
  --key-text:      #c8dff5;
  --key-used-bg:   #0d1117;
  --key-used-text: #1e2d40;
  --hp-full:       #00d4c8;
  --hp-mid:        #f5c842;
  --hp-low:        #ef4444;
  --text-dim:      #2a3a55;
}

html, body {
  height: 100%;
}

body {
  background: var(--bg-deep);
  background-image:
    linear-gradient(rgba(0,212,200,0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0,212,200,0.03) 1px, transparent 1px);
  background-size: 40px 40px;
  color: var(--tile-face);
  font-family: 'Share Tech Mono', monospace;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  padding: 1.5rem 1rem 2rem;
  gap: 1.25rem;
}

/* ── HEADER ─────────────────────────────────── */
.game-header {
  width: 100%;
  max-width: 420px;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}

h1 {
  font-family: 'Black Han Sans', sans-serif;
  font-size: 1.6rem;
  color: var(--accent-teal);
  letter-spacing: 0.05em;
  text-shadow: 0 0 20px var(--accent-glow);
}

.score-display {
  font-size: 0.7rem;
  letter-spacing: 0.15em;
  color: var(--text-dim);
  text-align: right;
  line-height: 1.6;
}

.score-display .score-val {
  color: var(--accent-warm);
}

/* ── HP BAR ─────────────────────────────────── */
.hp-container {
  width: 100%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.hp-header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.hp-label {
  font-size: 0.65rem;
  letter-spacing: 0.25em;
  text-transform: uppercase;
  color: var(--text-dim);
}

.hp-count {
  font-size: 0.75rem;
  color: var(--accent-teal);
  transition: color 0.4s ease;
}

.hp-count.mid { color: var(--hp-mid); }
.hp-count.low { color: var(--hp-low); }

.hp-track {
  width: 100%;
  height: 14px;
  background: #0d1117;
  border-radius: 4px;
  border: 1px solid #1a2235;
  padding: 2px;
  box-shadow: inset 0 2px 6px rgba(0,0,0,0.6);
  overflow: hidden;
}

.hp-fill {
  height: 100%;
  border-radius: 2px;
  width: 100%;
  transition:
    width 0.5s cubic-bezier(0.4, 0, 0.2, 1),
    background 0.5s ease,
    box-shadow 0.5s ease;
  background: var(--hp-full);
  box-shadow: 0 0 10px var(--accent-glow), 0 0 20px rgba(0,212,200,0.2);
  position: relative;
  overflow: hidden;
}

.hp-fill::after {
  content: '';
  position: absolute;
  top: 0;
  left: -60%;
  width: 40%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.25), transparent);
  animation: shine 2.5s ease-in-out infinite;
}

@keyframes shine {
  0%   { left: -60%; }
  100% { left: 130%; }
}

.hp-fill.mid {
  background: var(--hp-mid);
  box-shadow: 0 0 10px rgba(245,200,66,0.5), 0 0 20px rgba(245,200,66,0.2);
}

.hp-fill.low {
  background: var(--hp-low);
  box-shadow: 0 0 10px rgba(239,68,68,0.6), 0 0 20px rgba(239,68,68,0.3);
  animation: pulse-low 0.8s ease-in-out infinite;
}

@keyframes pulse-low {
  0%, 100% { opacity: 1; }
  50%       { opacity: 0.55; }
}

/* ── CATEGORY ───────────────────────────────── */
.category {
  font-size: 0.65rem;
  letter-spacing: 0.3em;
  text-transform: uppercase;
  color: var(--text-dim);
  text-align: center;
}

/* ── PUZZLE BOARD ───────────────────────────── */
.board {
  width: 100%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  min-height: 120px;
  justify-content: center;
}

.word-row {
  display: flex;
  gap: 0.3rem;
  flex-wrap: wrap;
  justify-content: center;
}

/* ── TILE ───────────────────────────────────── */
.tile-wrap {
  width: 38px;
  height: 46px;
  perspective: 600px;
}

.tile {
  width: 100%;
  height: 100%;
  position: relative;
  transform-style: preserve-3d;
  transition: transform 0.55s cubic-bezier(0.4, 0.0, 0.2, 1);
}

.tile.flipped {
  transform: rotateY(180deg);
}

.tile-front,
.tile-back {
  position: absolute;
  inset: 0;
  border-radius: 5px;
  backface-visibility: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tile-front {
  background: var(--tile-blank);
  border: 1px solid var(--tile-border);
  box-shadow:
    inset 0 1px 0 rgba(255,255,255,0.05),
    inset 0 -2px 0 rgba(0,0,0,0.3),
    0 4px 10px rgba(0,0,0,0.4);
}

.tile-front::after {
  content: '';
  position: absolute;
  top: 3px;
  left: 3px;
  right: 3px;
  height: 28%;
  background: linear-gradient(180deg, rgba(255,255,255,0.04) 0%, transparent 100%);
  border-radius: 3px;
}

.tile-back {
  background: linear-gradient(160deg, #0f2744 0%, var(--tile-revealed) 100%);
  border: 1px solid var(--accent-teal);
  transform: rotateY(180deg);
  box-shadow:
    0 0 10px var(--accent-glow),
    0 0 24px rgba(0,212,200,0.12),
    inset 0 1px 0 rgba(0,212,200,0.2);
}

.tile-back .letter {
  font-family: 'Black Han Sans', sans-serif;
  font-size: 1.25rem;
  color: var(--tile-face);
  text-shadow: 0 0 16px var(--accent-glow);
}

@keyframes reveal-flash {
  0%   {
    box-shadow:
      0 0 30px var(--accent-glow),
      0 0 60px rgba(0,212,200,0.3),
      inset 0 1px 0 rgba(0,212,200,0.5);
  }
  100% {
    box-shadow:
      0 0 10px var(--accent-glow),
      0 0 24px rgba(0,212,200,0.12),
      inset 0 1px 0 rgba(0,212,200,0.2);
  }
}

.tile.flipped .tile-back {
  animation: reveal-flash 0.6s ease-out 0.3s both;
}

.word-gap {
  width: 12px;
}

/* Board loading state */
.board-loading {
  font-size: 0.7rem;
  letter-spacing: 0.2em;
  color: var(--text-dim);
  text-align: center;
  animation: blink 1.2s ease-in-out infinite;
}

@keyframes blink {
  0%, 100% { opacity: 1; }
  50%       { opacity: 0.3; }
}

/* ── KEYBOARD ───────────────────────────────── */
.keyboard {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.35rem;
  width: 100%;
  max-width: 420px;
}

.key-row {
  display: flex;
  gap: 0.3rem;
  justify-content: center;
  width: 100%;
}

.key {
  flex: 1;
  min-width: 0;
  max-width: 52px;
  aspect-ratio: 1 / 1.15;

  font-family: 'Black Han Sans', sans-serif;
  font-size: clamp(0.8rem, 3.2vw, 1rem);
  color: var(--key-text);

  border: none;
  border-radius: 5px;
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: transparent;

  background: var(--key-top);
  box-shadow:
    0 4px 0 var(--key-shadow),
    0 5px 8px rgba(0,0,0,0.5),
    inset 0 1px 0 rgba(255,255,255,0.07);

  transition:
    transform 0.08s ease,
    box-shadow 0.08s ease,
    background 0.15s ease,
    color 0.15s ease;
}

.key:active:not(.used) {
  transform: translateY(3px);
  box-shadow:
    0 1px 0 var(--key-shadow),
    0 2px 4px rgba(0,0,0,0.5);
}

.key:hover:not(.used) {
  background: #243250;
  box-shadow:
    0 4px 0 var(--key-shadow),
    0 5px 8px rgba(0,0,0,0.5),
    0 0 14px var(--accent-glow),
    inset 0 1px 0 rgba(255,255,255,0.1);
  color: #fff;
}

.key.used {
  background: var(--key-used-bg);
  color: var(--key-used-text);
  box-shadow:
    0 2px 0 #050709,
    inset 0 1px 0 rgba(0,0,0,0.2);
  cursor: default;
  transform: translateY(2px);
}

.key.correct {
  animation: correct-flash 0.55s ease forwards;
}

@keyframes correct-flash {
  0% {
    background: var(--accent-teal);
    color: #000;
    box-shadow: 0 4px 0 #009e94, 0 0 24px var(--accent-glow);
    transform: translateY(0);
  }
  100% {
    background: var(--key-used-bg);
    color: var(--key-used-text);
    box-shadow: 0 2px 0 #050709;
    transform: translateY(2px);
  }
}

.key.wrong {
  animation: wrong-flash 0.55s ease forwards;
}

@keyframes wrong-flash {
  0% {
    background: #7f1d1d;
    color: #fca5a5;
    box-shadow: 0 4px 0 #450a0a, 0 0 24px rgba(239,68,68,0.45);
    transform: translateY(0);
  }
  100% {
    background: var(--key-used-bg);
    color: var(--key-used-text);
    box-shadow: 0 2px 0 #050709;
    transform: translateY(2px);
  }
}

/* ── STATUS MESSAGE ─────────────────────────── */
.status-message {
  font-size: 0.75rem;
  letter-spacing: 0.1em;
  text-align: center;
  color: var(--text-dim);
  min-height: 1.2em;
  transition: color 0.3s;
}

.status-message.win  { color: var(--accent-teal); }
.status-message.lose { color: var(--hp-low); }

/* ── RESET BUTTON ───────────────────────────── */
.btn-reset {
  font-family: 'Share Tech Mono', monospace;
  font-size: 0.75rem;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  padding: 0.55rem 1.6rem;
  border-radius: 4px;
  border: 1px solid var(--accent-teal);
  background: transparent;
  color: var(--accent-teal);
  cursor: pointer;
  transition: background 0.2s, box-shadow 0.2s;
}

.btn-reset:hover {
  background: rgba(0,212,200,0.08);
  box-shadow: 0 0 16px var(--accent-glow);
}

/* ── SCREEN SHAKE ───────────────────────────── */
@keyframes screen-shake {
  0%,100% { transform: translateX(0); }
  20%      { transform: translateX(-5px); }
  40%      { transform: translateX(5px); }
  60%      { transform: translateX(-3px); }
  80%      { transform: translateX(3px); }
}

body.shake {
  animation: screen-shake 0.3s ease;
}`, "",{"version":3,"sources":["webpack://./src/styles/style.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,uCAAuC;EACvC,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B;;qEAEmE;EACnE,0BAA0B;EAC1B,uBAAuB;EACvB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;AACd;;AAEA,kDAAkD;AAClD;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,yCAAyC;EACzC,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kDAAkD;AAClD;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,gBAAgB,oBAAoB,EAAE;AACtC,gBAAgB,oBAAoB,EAAE;;AAEtC;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX;;;wBAGsB;EACtB,0BAA0B;EAC1B,qEAAqE;EACrE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,UAAU;EACV,YAAY;EACZ,oFAAoF;EACpF,0CAA0C;AAC5C;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,yBAAyB;EACzB,wEAAwE;AAC1E;;AAEA;EACE,yBAAyB;EACzB,sEAAsE;EACtE,8CAA8C;AAChD;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,YAAY,aAAa,EAAE;AAC7B;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,kDAAkD;AAClD;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,uBAAuB;AACzB;;AAEA,kDAAkD;AAClD;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,0DAA0D;AAC5D;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC;;;8BAG4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,gFAAgF;EAChF,kBAAkB;AACpB;;AAEA;EACE,0EAA0E;EAC1E,oCAAoC;EACpC,0BAA0B;EAC1B;;;qCAGmC;AACrC;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE;IACE;;;uCAGmC;EACrC;EACA;IACE;;;uCAGmC;EACrC;AACF;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,YAAY,YAAY,EAAE;AAC5B;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,eAAe;EACf,sBAAsB;;EAEtB,yCAAyC;EACzC,qCAAqC;EACrC,sBAAsB;;EAEtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,wCAAwC;;EAExC,0BAA0B;EAC1B;;;wCAGsC;;EAEtC;;;;oBAIkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B;;6BAE2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB;;;;uCAIqC;EACrC,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B;;iCAE+B;EAC/B,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE;IACE,8BAA8B;IAC9B,WAAW;IACX,wDAAwD;IACxD,wBAAwB;EAC1B;EACA;IACE,8BAA8B;IAC9B,2BAA2B;IAC3B,2BAA2B;IAC3B,0BAA0B;EAC5B;AACF;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE;IACE,mBAAmB;IACnB,cAAc;IACd,0DAA0D;IAC1D,wBAAwB;EAC1B;EACA;IACE,8BAA8B;IAC9B,2BAA2B;IAC3B,2BAA2B;IAC3B,0BAA0B;EAC5B;AACF;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,uBAAuB,yBAAyB,EAAE;AAClD,uBAAuB,oBAAoB,EAAE;;AAE7C,kDAAkD;AAClD;EACE,yCAAyC;EACzC,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;EACpC,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA,kDAAkD;AAClD;EACE,UAAU,wBAAwB,EAAE;EACpC,WAAW,2BAA2B,EAAE;EACxC,WAAW,0BAA0B,EAAE;EACvC,WAAW,2BAA2B,EAAE;EACxC,WAAW,0BAA0B,EAAE;AACzC;;AAEA;EACE,iCAAiC;AACnC","sourcesContent":["*, *::before, *::after {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n:root {\n  --bg-deep:       #0a0e1a;\n  --bg-panel:      #111827;\n  --tile-blank:    #1a2235;\n  --tile-border:   #2a3a55;\n  --tile-revealed: #0d1f3c;\n  --tile-face:     #e8f4ff;\n  --accent-teal:   #00d4c8;\n  --accent-glow:   rgba(0, 212, 200, 0.4);\n  --accent-warm:   #f5c842;\n  --key-top:       #1f2d45;\n  --key-shadow:    #080d18;\n  --key-text:      #c8dff5;\n  --key-used-bg:   #0d1117;\n  --key-used-text: #1e2d40;\n  --hp-full:       #00d4c8;\n  --hp-mid:        #f5c842;\n  --hp-low:        #ef4444;\n  --text-dim:      #2a3a55;\n}\n\nhtml, body {\n  height: 100%;\n}\n\nbody {\n  background: var(--bg-deep);\n  background-image:\n    linear-gradient(rgba(0,212,200,0.03) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(0,212,200,0.03) 1px, transparent 1px);\n  background-size: 40px 40px;\n  color: var(--tile-face);\n  font-family: 'Share Tech Mono', monospace;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-height: 100vh;\n  padding: 1.5rem 1rem 2rem;\n  gap: 1.25rem;\n}\n\n/* ── HEADER ─────────────────────────────────── */\n.game-header {\n  width: 100%;\n  max-width: 420px;\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n}\n\nh1 {\n  font-family: 'Black Han Sans', sans-serif;\n  font-size: 1.6rem;\n  color: var(--accent-teal);\n  letter-spacing: 0.05em;\n  text-shadow: 0 0 20px var(--accent-glow);\n}\n\n.score-display {\n  font-size: 0.7rem;\n  letter-spacing: 0.15em;\n  color: var(--text-dim);\n  text-align: right;\n  line-height: 1.6;\n}\n\n.score-display .score-val {\n  color: var(--accent-warm);\n}\n\n/* ── HP BAR ─────────────────────────────────── */\n.hp-container {\n  width: 100%;\n  max-width: 420px;\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n}\n\n.hp-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n}\n\n.hp-label {\n  font-size: 0.65rem;\n  letter-spacing: 0.25em;\n  text-transform: uppercase;\n  color: var(--text-dim);\n}\n\n.hp-count {\n  font-size: 0.75rem;\n  color: var(--accent-teal);\n  transition: color 0.4s ease;\n}\n\n.hp-count.mid { color: var(--hp-mid); }\n.hp-count.low { color: var(--hp-low); }\n\n.hp-track {\n  width: 100%;\n  height: 14px;\n  background: #0d1117;\n  border-radius: 4px;\n  border: 1px solid #1a2235;\n  padding: 2px;\n  box-shadow: inset 0 2px 6px rgba(0,0,0,0.6);\n  overflow: hidden;\n}\n\n.hp-fill {\n  height: 100%;\n  border-radius: 2px;\n  width: 100%;\n  transition:\n    width 0.5s cubic-bezier(0.4, 0, 0.2, 1),\n    background 0.5s ease,\n    box-shadow 0.5s ease;\n  background: var(--hp-full);\n  box-shadow: 0 0 10px var(--accent-glow), 0 0 20px rgba(0,212,200,0.2);\n  position: relative;\n  overflow: hidden;\n}\n\n.hp-fill::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -60%;\n  width: 40%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.25), transparent);\n  animation: shine 2.5s ease-in-out infinite;\n}\n\n@keyframes shine {\n  0%   { left: -60%; }\n  100% { left: 130%; }\n}\n\n.hp-fill.mid {\n  background: var(--hp-mid);\n  box-shadow: 0 0 10px rgba(245,200,66,0.5), 0 0 20px rgba(245,200,66,0.2);\n}\n\n.hp-fill.low {\n  background: var(--hp-low);\n  box-shadow: 0 0 10px rgba(239,68,68,0.6), 0 0 20px rgba(239,68,68,0.3);\n  animation: pulse-low 0.8s ease-in-out infinite;\n}\n\n@keyframes pulse-low {\n  0%, 100% { opacity: 1; }\n  50%       { opacity: 0.55; }\n}\n\n/* ── CATEGORY ───────────────────────────────── */\n.category {\n  font-size: 0.65rem;\n  letter-spacing: 0.3em;\n  text-transform: uppercase;\n  color: var(--text-dim);\n  text-align: center;\n}\n\n/* ── PUZZLE BOARD ───────────────────────────── */\n.board {\n  width: 100%;\n  max-width: 420px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n  min-height: 120px;\n  justify-content: center;\n}\n\n.word-row {\n  display: flex;\n  gap: 0.3rem;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n/* ── TILE ───────────────────────────────────── */\n.tile-wrap {\n  width: 38px;\n  height: 46px;\n  perspective: 600px;\n}\n\n.tile {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  transform-style: preserve-3d;\n  transition: transform 0.55s cubic-bezier(0.4, 0.0, 0.2, 1);\n}\n\n.tile.flipped {\n  transform: rotateY(180deg);\n}\n\n.tile-front,\n.tile-back {\n  position: absolute;\n  inset: 0;\n  border-radius: 5px;\n  backface-visibility: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.tile-front {\n  background: var(--tile-blank);\n  border: 1px solid var(--tile-border);\n  box-shadow:\n    inset 0 1px 0 rgba(255,255,255,0.05),\n    inset 0 -2px 0 rgba(0,0,0,0.3),\n    0 4px 10px rgba(0,0,0,0.4);\n}\n\n.tile-front::after {\n  content: '';\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  right: 3px;\n  height: 28%;\n  background: linear-gradient(180deg, rgba(255,255,255,0.04) 0%, transparent 100%);\n  border-radius: 3px;\n}\n\n.tile-back {\n  background: linear-gradient(160deg, #0f2744 0%, var(--tile-revealed) 100%);\n  border: 1px solid var(--accent-teal);\n  transform: rotateY(180deg);\n  box-shadow:\n    0 0 10px var(--accent-glow),\n    0 0 24px rgba(0,212,200,0.12),\n    inset 0 1px 0 rgba(0,212,200,0.2);\n}\n\n.tile-back .letter {\n  font-family: 'Black Han Sans', sans-serif;\n  font-size: 1.25rem;\n  color: var(--tile-face);\n  text-shadow: 0 0 16px var(--accent-glow);\n}\n\n@keyframes reveal-flash {\n  0%   {\n    box-shadow:\n      0 0 30px var(--accent-glow),\n      0 0 60px rgba(0,212,200,0.3),\n      inset 0 1px 0 rgba(0,212,200,0.5);\n  }\n  100% {\n    box-shadow:\n      0 0 10px var(--accent-glow),\n      0 0 24px rgba(0,212,200,0.12),\n      inset 0 1px 0 rgba(0,212,200,0.2);\n  }\n}\n\n.tile.flipped .tile-back {\n  animation: reveal-flash 0.6s ease-out 0.3s both;\n}\n\n.word-gap {\n  width: 12px;\n}\n\n/* Board loading state */\n.board-loading {\n  font-size: 0.7rem;\n  letter-spacing: 0.2em;\n  color: var(--text-dim);\n  text-align: center;\n  animation: blink 1.2s ease-in-out infinite;\n}\n\n@keyframes blink {\n  0%, 100% { opacity: 1; }\n  50%       { opacity: 0.3; }\n}\n\n/* ── KEYBOARD ───────────────────────────────── */\n.keyboard {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.35rem;\n  width: 100%;\n  max-width: 420px;\n}\n\n.key-row {\n  display: flex;\n  gap: 0.3rem;\n  justify-content: center;\n  width: 100%;\n}\n\n.key {\n  flex: 1;\n  min-width: 0;\n  max-width: 52px;\n  aspect-ratio: 1 / 1.15;\n\n  font-family: 'Black Han Sans', sans-serif;\n  font-size: clamp(0.8rem, 3.2vw, 1rem);\n  color: var(--key-text);\n\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  user-select: none;\n  -webkit-tap-highlight-color: transparent;\n\n  background: var(--key-top);\n  box-shadow:\n    0 4px 0 var(--key-shadow),\n    0 5px 8px rgba(0,0,0,0.5),\n    inset 0 1px 0 rgba(255,255,255,0.07);\n\n  transition:\n    transform 0.08s ease,\n    box-shadow 0.08s ease,\n    background 0.15s ease,\n    color 0.15s ease;\n}\n\n.key:active:not(.used) {\n  transform: translateY(3px);\n  box-shadow:\n    0 1px 0 var(--key-shadow),\n    0 2px 4px rgba(0,0,0,0.5);\n}\n\n.key:hover:not(.used) {\n  background: #243250;\n  box-shadow:\n    0 4px 0 var(--key-shadow),\n    0 5px 8px rgba(0,0,0,0.5),\n    0 0 14px var(--accent-glow),\n    inset 0 1px 0 rgba(255,255,255,0.1);\n  color: #fff;\n}\n\n.key.used {\n  background: var(--key-used-bg);\n  color: var(--key-used-text);\n  box-shadow:\n    0 2px 0 #050709,\n    inset 0 1px 0 rgba(0,0,0,0.2);\n  cursor: default;\n  transform: translateY(2px);\n}\n\n.key.correct {\n  animation: correct-flash 0.55s ease forwards;\n}\n\n@keyframes correct-flash {\n  0% {\n    background: var(--accent-teal);\n    color: #000;\n    box-shadow: 0 4px 0 #009e94, 0 0 24px var(--accent-glow);\n    transform: translateY(0);\n  }\n  100% {\n    background: var(--key-used-bg);\n    color: var(--key-used-text);\n    box-shadow: 0 2px 0 #050709;\n    transform: translateY(2px);\n  }\n}\n\n.key.wrong {\n  animation: wrong-flash 0.55s ease forwards;\n}\n\n@keyframes wrong-flash {\n  0% {\n    background: #7f1d1d;\n    color: #fca5a5;\n    box-shadow: 0 4px 0 #450a0a, 0 0 24px rgba(239,68,68,0.45);\n    transform: translateY(0);\n  }\n  100% {\n    background: var(--key-used-bg);\n    color: var(--key-used-text);\n    box-shadow: 0 2px 0 #050709;\n    transform: translateY(2px);\n  }\n}\n\n/* ── STATUS MESSAGE ─────────────────────────── */\n.status-message {\n  font-size: 0.75rem;\n  letter-spacing: 0.1em;\n  text-align: center;\n  color: var(--text-dim);\n  min-height: 1.2em;\n  transition: color 0.3s;\n}\n\n.status-message.win  { color: var(--accent-teal); }\n.status-message.lose { color: var(--hp-low); }\n\n/* ── RESET BUTTON ───────────────────────────── */\n.btn-reset {\n  font-family: 'Share Tech Mono', monospace;\n  font-size: 0.75rem;\n  letter-spacing: 0.15em;\n  text-transform: uppercase;\n  padding: 0.55rem 1.6rem;\n  border-radius: 4px;\n  border: 1px solid var(--accent-teal);\n  background: transparent;\n  color: var(--accent-teal);\n  cursor: pointer;\n  transition: background 0.2s, box-shadow 0.2s;\n}\n\n.btn-reset:hover {\n  background: rgba(0,212,200,0.08);\n  box-shadow: 0 0 16px var(--accent-glow);\n}\n\n/* ── SCREEN SHAKE ───────────────────────────── */\n@keyframes screen-shake {\n  0%,100% { transform: translateX(0); }\n  20%      { transform: translateX(-5px); }\n  40%      { transform: translateX(5px); }\n  60%      { transform: translateX(-3px); }\n  80%      { transform: translateX(3px); }\n}\n\nbody.shake {\n  animation: screen-shake 0.3s ease;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
